
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import API from "../services/api";
import "./HomePage.css";

// Convert UTC timestamps from Django to the visitor's local timezone
const formatLocalTime = (timestamp) => {
    if (!timestamp || timestamp === "N/A") {
        return "N/A";
    }

    let value = String(timestamp).trim();

    // Support old Django timestamps:
    // 2026-10-14 03:58:46
    // And new ISO timestamps:
    // 2026-10-14T03:58:46.056779+00:00
    value = value.replace(" ", "T");

    // Legacy timestamps without an offset represent UTC
    if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(value)) {
        value += "Z";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
        return "N/A";
    }

    // No fixed timezone: use the visitor's device timezone
    return new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
        timeZoneName: "shortOffset",
    }).format(date);
};

const HomePage = () => {
    const [tags, setTags] = useState([]);

    useEffect(() => {
        const fetchTags = async () => {
            try {
                const response = await API.get(
                    "/latest-tag-values/"
                );

                setTags(response.data);
            } catch (error) {
                console.error(
                    "Error fetching tags:",
                    error
                );
            }
        };

        fetchTags();

        // Refresh tag values every 5 seconds
        const interval = setInterval(fetchTags, 5000);

        return () => clearInterval(interval);
    }, []);

    // Display numeric values with two decimal places
    const formatValue = (value) => {
        if (typeof value === "number") {
            return value.toFixed(2);
        }

        return value;
    };

    const localTimezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone ||
        "Local Time";

    return (
        <div className="container">
            <h1 className="title">
                Welcome to the OPC Management System
            </h1>

            <div className="button-group">
                <Link to="/add-server">
                    <button className="btn">
                        Add Server
                    </button>
                </Link>

                <Link to="/add-tag">
                    <button className="btn">
                        Add Tag
                    </button>
                </Link>
            </div>

            <h2 className="table-title">
                OPC Tags
            </h2>

            <p
                style={{
                    fontSize: "13px",
                    color: "#64748b",
                    marginBottom: "12px",
                }}
            >
                Display Timezone: {localTimezone}
            </p>

            <div className="table-container">
                <table className="tags-table">
                    <thead>
                        <tr>
                            <th>Tag Name</th>
                            <th>Last Value</th>
                            <th>Timestamp</th>
                            <th>Server</th>
                        </tr>
                    </thead>

                    <tbody>
                        {tags.length > 0 ? (
                            tags.map((tag, index) => (
                                <tr key={index}>
                                    <td>
                                        {tag.tag_name}
                                    </td>

                                    <td>
                                        {formatValue(
                                            tag.last_value
                                        )}
                                    </td>

                                    <td>
                                        {formatLocalTime(
                                            tag.timestamp
                                        )}
                                    </td>

                                    <td>
                                        {tag.server_name}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan="4"
                                    className="no-data"
                                >
                                    No tags found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default HomePage;
